import React from "react";
import { SelectorComponent } from "./styled";
var Selector = function (_a) {
    var name = _a.name, _b = _a.uuid, uuid = _b === void 0 ? "" : _b, onClick = _a.onClick, selected = _a.selected, className = _a.className;
    return (React.createElement(SelectorComponent, { selected: selected, onClick: function () { return onClick(uuid); }, className: className }, name));
};
export default Selector;
